<template>
  <svg preserveAspectRatio="xMidYMax slice" viewBox="0 0 1460 500" id="canvas"></svg>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import formatter from './formatter.mixin.js';

export default {
  name: 'my-map',
  props: [
    'template',
    'groups'
  ],
  mixins: [formatter],
  mounted() {
    var canvas = this.$svg.get('#canvas').size('100%','100%');

    canvas.svg(this.template);

    var i;

    for(i = 0; i < this.groups.length; i++) {
      var group = this.groups[i];
      var statusGroupID = '#group-' + group.id;
      var groupLink = '/#/groups/' + group.id;

      var element = this.$svg.get(statusGroupID);

      if(element === null) {
        continue;
      }

      /* element.on('mouseover', function(e){ */
      /*   console.log(e); */
      /* }); */

      element.linkTo(groupLink);

      if(group.elevators == null) {
        continue;
      }
      
      //element.attr('opacity', 0.7);

      element.attr('class', this.statusClassForGroup(group));
    }
  },
  beforeDestroy() {
  },
  methods: {
  },
}
</script>

<style>
svg {
}
</style>



// WEBPACK FOOTER //
// src/Map.vue